import SchemesColorsPage from "../../../../src/components/SchemesColorsPage";
import * as React from 'react';
export default {
  SchemesColorsPage,
  React
};